import { isPreviewableFilename, storageKeyExtension } from '@klear/upload/content-type'

export function isBrowserRenderable(uploadedFilename: string | null): boolean {
  return (
    uploadedFilename === null || storageKeyExtension(uploadedFilename) === '' || isPreviewableFilename(uploadedFilename)
  )
}

export function isImageDocument(uploadedFilename: string | null): boolean {
  return uploadedFilename !== null && !isPdfDocument(uploadedFilename) && isPreviewableFilename(uploadedFilename)
}

export function isPdfDocument(uploadedFilename: string | null): boolean {
  return uploadedFilename !== null && storageKeyExtension(uploadedFilename) === 'pdf'
}
